import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@ts-digital/vrc";
import React from "react";
import { useSelector } from "react-redux";

const FulfilmentCreateCustomers = props => {
  const { handleCompanyClick, handleAllCompaniesClick, selectedCompanies } = props;

  const backofficeCustomers = useSelector(state => state.fulfilments.backofficeCustomers);

  return (
    <>
      <div className="fulfilment-create-dialog-company-addAll">
        <Button kind="tertiary" onClick={handleAllCompaniesClick}>
          <FontAwesomeIcon icon={["fal", "plus"]} style={{ marginRight: 10 }} />{" "}
          Aggiungi tutti
        </Button>
      </div>
      <div className="fulfilment-create-dialog-company-list-container">
        <div className="fulfilment-create-dialog-company-list">
          {backofficeCustomers?.map(it => {
            return (
              <div
                key={"fulfilment-create-dialog-company_" + it.customerId}
                id={"fulfilment-create-dialog-company_" + it.customerId}
                className={"fulfilment-create-dialog-company-list-item" + (selectedCompanies.indexOf(it.customerId) > -1 ? " selected" : "")}
                onClick={() => {
                  handleCompanyClick(it.customerId);
                }}
              >
                <div className="fulfilment-create-dialog-company-name">
                  {it.customerName}
                </div>
                <div className="fulfilment-create-dialog-company-action">
                  <div
                    className={
                      "fulfilment-create-dialog-company-action-icon " +
                      (selectedCompanies.indexOf(it.customerId) > -1
                        ? "icon-minus"
                        : "icon-plus")
                    }
                  >
                    <FontAwesomeIcon
                      icon={[
                        "far",
                        selectedCompanies.indexOf(it.customerId) > -1
                          ? "minus-circle"
                          : "plus-circle"
                      ]}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default FulfilmentCreateCustomers;
